import {getField} from 'vuex-map-fields';

export default {
    getField,

    credentialType: state => {
        if (null !== state.credentialTypeName) {
            return state.credentialTypes.find(o => o.type === state.credentialTypeName) || null;
        }

        return null;
    },

    credentials: (state, getters) => {
        const credentialsType = getters.credentialType;

        if (credentialsType) {
            return credentialsType.credentials
        }

        return [];
    }
};
